module.exports = __webpack_public_path__ + "static/media/prop-3.97c6029f.png";